import { useTranslations } from 'next-intl'

import { Card, ZContractStatus } from '@/entities/contract'
import { cn } from '@/shared/lib'
import { ContentBox } from '@/shared/ui'

import * as Accordion from './status-accordion'
import { useCurrentStepLabel } from './step'
import { StatusStepper, Props as StatusStepperProps } from './stepper'

export type Props = StatusStepperProps & {
  contractStatusDescription: string
}

export const ContractStatus = ({
  contractStatusDescription,
  ...restProps
}: Props) => {
  const t = useTranslations('lease_detail')

  const { contractStatus, refundStatus } = restProps

  const isPayReadyStatus = contractStatus === ZContractStatus.enum.PAY_READY

  const currentStepLabel = useCurrentStepLabel(contractStatus, refundStatus)

  return (
    <Card.Root spacing="large">
      <Card.Item>
        <Card.ItemTitle>{t('lease_status.title')}</Card.ItemTitle>
        <Card.ItemContent>
          <Accordion.Root value="status">
            <Accordion.Trigger
              className={cn(isPayReadyStatus && 'text-purple-500')}
            >
              {currentStepLabel}
            </Accordion.Trigger>

            <ContentBox color="purple" className="mt-3" align="center">
              {contractStatusDescription}
            </ContentBox>

            <Accordion.Content className="mt-4">
              <StatusStepper {...restProps} />
            </Accordion.Content>
          </Accordion.Root>
        </Card.ItemContent>
      </Card.Item>
    </Card.Root>
  )
}
